window.AboutChild = (function ($, validation) {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            buttons: {
                cancelButton: '#about-child-form-cancel-button',
                continueButton: '#about-child-form-continue-button'
            },
            messages:{
                invalidFormMessage: '#about-child-form-invalid-form-message'
            },
            dropdown:{
                selectedTitle: '#about-child-form-title option:selected',
                title: '#about-child-form-title'
            },
            textBox:{
                section: '#about-child-form-section',
                firstname: '#about-child-form-firstname',
                surname: '#about-child-form-surname',
                day: '#about-child-form-day',
                month: '#about-child-form-month',
                year: '#about-child-form-year',
            },
            radioButton:{
                selectedGenderAtBirth: '[name="GenderAtBirth"] input[type="radio"]:checked'
            },
            hiddenField:{
                addChildrenCount: '#about-child-form-add-children-count'
            }
        },
        css:{
            invalidTextBoxError : 'vds-form__input--invalid',
            invalidRadioButtonError : 'vds-form__radios--error',
            radioGroup: '.vds-form__radios--contained',
            aboutChild : '.vds-about-child'
        },
        urls: {
            errorPageUrl: '/error/error-page',
            manageMembers: '/my-health-insurance/manage-my-plan/manage-members',
            resetSession: '/api/sitecore/AddMembers/ResetSession',
            cacheChildrenDetails: '/api/sitecore/AddMembers/CacheChildrenDetails',
            reviewDetails: '/my-health-insurance/manage-my-plan/add-members/review-details',
            dependentCount: '/my-health-insurance/manage-my-plan/add-members/dependent-count'
        },
        statusDescription: {
            ok: 'OK',
            badRequest: 'BadRequest'
        },
        func: {
            init: function () {
                self.func.bindings();
                $('body').on('submit', '#about-child-form', function (event) {
                    self.func.cacheChildrenInformationRequest(event);
                });
            },
            bindings: function () {
                $(self.elements.buttons.cancelButton).on('click', self.func.cancelChildrenInformationRequest);
            },
            cancelChildrenInformationRequest: function (event) {
                event.preventDefault();
                // AJAX call to reset the session.
                $.post(self.urls.resetSession)
                    .done(function () {
                        window.location.href = self.urls.manageMembers;
                    })
                    .fail(function () {
                        window.location.href = self.urls.errorPageUrl;
                    });
            },
            cacheChildrenInformationRequest: function (event) {
                event.preventDefault();
                const formData = self.func.gatherFormData();
                self.func.sendFormData(formData);
            },
            gatherFormData: function () {
                let request = [];
                const addChildrenCount = $(self.elements.hiddenField.addChildrenCount).val().trim();
                for (let i = 1; i <= addChildrenCount; i++) {
                    const dayDigits = 2;
                    const monthDigits = 2;
                    const yearDigits = 4;
                    const sectionId = '#about-child-form-section-'+i;
                    const firstnameId = '#about-child-form-firstname-'+i;
                    const surnameId = '#about-child-form-surname-'+i;
                    const dayId = '#about-child-form-day-'+i;
                    const monthId = '#about-child-form-month-'+i;
                    const yearId = '#about-child-form-year-'+i;
                    const selectedTitleId = '#about-child-form-title-' +i+ ' option:selected';

                    const guid = $(sectionId).attr('data-dep-guid');
                    const firstName = $(firstnameId).val().trim();
                    const surname = $(surnameId).val().trim();
                    const title = $(selectedTitleId).val().trim();
                    const day = $(dayId).val().trim().padStart(dayDigits, '0');
                    const month = $(monthId).val().trim().padStart(monthDigits, '0');
                    const year = $(yearId).val().trim().padStart(yearDigits, '0');
                    const genderAtBirth = $(sectionId).find(self.elements.radioButton.selectedGenderAtBirth).val();
                    request.push({
                        guid: guid,
                        title: title,
                        firstName: firstName,
                        lastName: surname,
                        dateOfBirth: `${year}-${month}-${day}`,
                        genderAtBirth: genderAtBirth
                    });
                }
                return request;
            },
            sendFormData: function (formData) {
                $.ajax({
                    url: self.urls.cacheChildrenDetails,
                    method: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify(formData),
                    success: function (response) {
                        if (response.statusCode === self.statusDescription.ok) {
                            window.location.href = self.urls.reviewDetails;
                        } else if (response.statusCode === self.statusDescription.badRequest) {
                            validation.setCustomErrors(response.errors);
                        } else {
                            window.location.href = self.urls.errorPageUrl;
                        }
                    },
                    error: function () {
                        window.location.href = self.urls.errorPageUrl;
                    }
                });
            }
        }
    };

    return {
        Init: self.func.init
    };
})(window.jQuery, window.Validation);

$(document).ready(function () {
    if ('aboutChild' === $('#about-child-form').data('feature')) {
        window.AboutChild.Init();
    }
});
